/* eslint-disable spellcheck/spell-checker */
import React from 'react';
import {useTranslation} from 'react-i18next';
import * as css from './TypewriterIllustration.css';
import {STATIC_PATH} from '../../config/config';
import {getStaticImage} from '../../globalVariables/GlobalVariables';

/**
 * Looped video animation for the AI save loader (asset from design; MP4 in `public/media`).
 * Flying stars use the design PNG; mask uses image brightness so the black plate does not show on light UI.
 */
function TypewriterIllustration() {
    const {t} = useTranslation('whatsapp');
    const videoSrc = `${STATIC_PATH}media/Typewriter.mp4`;
    const starSrc = getStaticImage('star.png');

    return (
        <css.illustrationRoot>
            <css.starsLayer aria-hidden>
                {Array.from({length: 4}, (_, i) => (
                    <css.flyingStar key={i}>
                        <css.flyingStarImg
                            src={starSrc}
                            alt=""
                            draggable={false}
                        />
                    </css.flyingStar>
                ))}
            </css.starsLayer>
            <css.loaderVideo
                src={videoSrc}
                autoPlay
                loop
                muted
                playsInline
                preload="auto"
                aria-label={t('aiSaveLoader.illustrationAlt')}
            />
        </css.illustrationRoot>
    );
}

export default TypewriterIllustration;
